export const facilityDetails = {
  name: 'Amazing Grace Health Care and Diagonistics',
  address: 'Plot 27, Oli Division, Obolokofuku, Adwa Rd, Tanganyika Ward',
  city: 'Arua',
  country: 'Uganda',
  contact: '+256 778 408548 / +256 786752250',
  email: 'ama@gmail.com',
};
